<ngx-avatars
  [src]="src"
  [name]="name"
  [value]="value"
  [size]="size"
  [initialsSize]="initialsSize"
  [textSizeRatio]="textSizeRatio"
  [fgColor]="avatarFgColor"
  [bgColor]="avatarBgColor"
>
</ngx-avatars>
